import { render, staticRenderFns } from "./InDetail.vue?vue&type=template&id=0c97a4ef&scoped=true"
import script from "./InDetail.vue?vue&type=script&lang=js"
export * from "./InDetail.vue?vue&type=script&lang=js"
import style0 from "./InDetail.vue?vue&type=style&index=0&id=0c97a4ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c97a4ef",
  null
  
)

export default component.exports